export default async function ({ store, redirect, route, app }) {
    const isLogged = store.state.frontend.auth.isLogged
    if (!isLogged) {
      if (process.client) {
        return window.location.href = '/auth/login?redirect=' + encodeURIComponent(route.fullPath);
      } else {
        return redirect('/auth/login?redirect=' + encodeURIComponent(route.fullPath));
      }
    }
  }